import React, { useState } from 'react';
import apiFetch from '@wordpress/api-fetch';
import { Container, Title, Button } from "@bsf/force-ui";
import { LoaderCircle } from "lucide-react";
import { Toaster, toast } from 'react-hot-toast';
import { __, sprintf } from '@wordpress/i18n';
import { LockOpen } from 'lucide-react';

const License = () => {
	const [licenseKey, setlicenseKey] = useState('');
	const [loading, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const licenseStatus = uaelSettingsData.license_status;
	const licensePlaceholder = licenseStatus ? __('Your license is active.', 'uael') : __('Paste your license key here', 'uael');

	const activateHandler = () => {
		if (!licenseKey) {
			toast.error(__('Please enter a valid license key!', 'uael'));
			setErrorMessage(__('Enter a valid license key!', 'uael'));
			return;
		}

		setLoading(true);
		setErrorMessage('');

		const formData = new window.FormData();
		formData.append('key', licenseKey);
		formData.append('action', 'uael_license_activation');
		formData.append('security', uaelSettingsData.license_activation_nonce);

		apiFetch({
			url: uaelSettingsData.ajax_url,
			method: 'POST',
			body: formData,
		}).then((data) => {
			setLoading(false);
			if (data.success) {
				toast.success(__('License successfully validated!', 'uael'));
				location.reload();
			} else {
				toast.error(data.message || __('Please enter a valid license key!', 'uael'));
				setErrorMessage(data.message || __('Enter a valid license key!', 'uael')); // Set error message.
			}
		});
	};

	const deactivateHandler = () => {
		setLoading(true);
		setErrorMessage('');

		const formData = new window.FormData();
		formData.append('action', 'uael_license_deactivation');
		formData.append('security', uaelSettingsData.license_deactivation_nonce);

		apiFetch({
			url: uaelSettingsData.ajax_url,
			method: 'POST',
			body: formData,
		}).then((data) => {
			setLoading(false);
			if (data.success) {
				toast.success(__('License successfully deactivated!', 'uael')); // Show toast notification on success
				location.reload();
			} else {
				toast.error(data.message || __('An error occurred while deactivating license.', 'uael'));
				setErrorMessage(data.message || __('An error occurred while deactivating license.', 'uael'));
			}
		});
	};

	return (
		<>
			<Toaster
				position="top-right"
				reverseOrder={false}
				gutter={8}
				containerStyle={{
					top: 20,
					right: 20,
					marginTop: '40px',
				}}
				toastOptions={{
					duration: 5000,
					style: {
						background: 'white',
					},
					success: {
						duration: 3000,
						iconTheme: {
							primary: '#6005ff',
							secondary: '#fff',
						},
					},
				}}
			/>
			<Container
				align="stretch"
				className="bg-background-primary p-6 rounded-lg "
				containerType="flex"
				direction="column"
				gap=""
				justify="start"
				style={{
					marginTop: "24px",
				}}
			>
				<Container.Item className="flex flex-col space-y-2">
					<span className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-solid p-1" style={{ borderColor: 'rgb(230, 230, 239)' }}>
						<LockOpen size={24} className="text-gray-600" />
					</span>
					<h3 className='m-0 flex items-center text-2xl font-semibold'>{licenseStatus ? __('Your License', 'uael') : __('License not active', 'uael')}</h3>
					{licenseStatus ? (
						<p className="text-sm font-normal m-0">
							{sprintf(
								__('You are using %s Pro!', 'uael'),
								uaelSettingsData.plugin_short_name
							)}
						</p>
					) : (
						<>
							<p className="text-sm font-normal m-0">
								{__('Activate', 'uael')}{' '}
								<a
									href="https://ultimateelementor.com/pricing/?utm_source=free-plugin&utm_medium=dashboard&utm_campaign=upgrade"
									target="_blank"
									rel="noopener noreferrer"
									className='text-link-primary'
									style = {{ color:'#6005FF', }}
								>
									{uaelSettingsData.plugin_short_name} Pro
								</a>{' '}
								{__(
									'to get professional support and automatic updates from your WordPress dashboard.',
									'uael'
								)}
							</p>
							<p className="text-sm font-normal m-0">
								{sprintf(
									__('Please enter your valid license key below to activate %s Pro!', 'uael'),
									uaelSettingsData.plugin_short_name
								)}{' '}
								<a
									href="https://store.brainstormforce.com/account/"
									target="_blank"
									rel="noopener noreferrer"
									className='text-link-primary'
									style = {{ color:'#6005FF', }}
								>
									
									{__(
									'Click Here',
									'uael'
								)}
								</a>{' '}
								{__(
									'to find your license key.',
									'uael'
								)}
							</p>
						</>
					)}
				</Container.Item>
				<Container.Item
						className="flex flex-col lg:flex-row gap-1 items-center mt-2 mb-2"
						alignSelf="auto"
						order="none"
					>
						<input
							value={licenseKey}
							onChange={(e) => setlicenseKey(e.target.value)}
							placeholder={licensePlaceholder}
							readOnly={licenseStatus}
							size="md"
							type="text"
							className={`w-full shrink ${licenseStatus ? 'uael-green-placeholder' : 'uael-default-placeholder'}`}
							style={{
								height: '48px',
								outline: 'none',       // Removes the default outline
								boxShadow: 'none',     // Removes the default box shadow
								borderColor: errorMessage ? 'red' : '#e0e0e0',
							}}
							onFocus={(e) => e.target.style.borderColor = '#6005FF'} // Apply focus color
							onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}  // Revert to default color
						/>
						<div className='cursor-pointer shrink'
							style={{ minWidth: "fit-content" }}>
							<Button
								icon={loading ? <LoaderCircle className="animate-spin" /> : null}
								iconPosition="left"
								style = {{ paddingTop: '14px', paddingBottom: '14px', borderColor: '#6005FF', outline: 'none', }}
								className="bg-[#6005FF] rounded-md border border-solid hover:bg-[#6005FF]"
								variant="primary"
								onMouseEnter={(e) =>
									(e.currentTarget.style.backgroundColor =
										"#4B00CC")
								}
								onMouseLeave={(e) =>
									(e.currentTarget.style.backgroundColor =
										"#6005FF")
								}
								onClick={licenseStatus ? deactivateHandler : activateHandler}
								disabled={loading} // Disable button during loading to prevent multiple clicks.
							>
								{loading
									? (licenseStatus ? __('Deactivating...', 'uael') : __('Activating...', 'uael'))
									: (licenseStatus ? __('Deactivate', 'uael') : __('Activate', 'uael'))}
							</Button>
						</div>		
				</Container.Item>
				<p className="m-0 text-sm font-semibold text-link-primary no-underline mb-2">
							<a className='no-underline'
								href={
									licenseStatus
										? 'https://ultimateelementor.com/pricing/?utm_source=pro-plugin&utm_medium=dashboard&utm_campaign=more-upgrade'
										: 'https://store.brainstormforce.com/support'
								}
								target="_blank"
								rel="noopener noreferrer"
								style = {{ color:'#6005FF', }}
							>
								{licenseStatus
									? __('Get another license?', 'uael')
									: __('Need Help?', 'uael')}
							</a>
				</p>	
				{errorMessage && (
					<p className="text-red-500 text-xs" style={{ color: 'red', marginTop: "-10px" }}>{errorMessage}</p> // Show error message below the input field
				)}
			</Container>
		</>
	);
};

export default License;
